<script lang="ts" setup>
import KlereoModal from "@/shared/components/KlereoModal.vue";
import { ref } from "vue";
import { useBleDeviceId } from "@/features/ble/utils/useBleDeviceId.ts";
import PoolParamsModal from "@/features/pool/header/PoolParamsModalContent.vue";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";

const opened = ref(false);
const deviceId = useBleDeviceId();
</script>

<template>
  <button @click="opened = true" v-if="deviceId">
    <klereo-icon name="bluetooth" class="cursor-pointer w-[30px]" />
  </button>
  <klereo-modal
    :opened="opened"
    :with-close-button="true"
    @close="opened = false"
  >
    <pool-params-modal />

    <div class="text-center mt-5">
      <div class="btn--secondary" @click="opened = false">
        {{ $t("Close") }}
      </div>
    </div>
  </klereo-modal>
</template>
